import { Key } from 'react'
import { Item } from '@react-stately/collections'
import Styles from './ConfigureReviewAutomationModal.module.scss'
import { Menu } from 'components/Menu/Menu'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { ReactComponent as AddIcon } from 'assets/icons/add24.svg'
import { rolesMenuItems } from './utils'
import { Button } from 'components/Button/Button'
import { ReviewerRole } from 'components/ReviewsWizard/types'

export type Props = {
  handleAction: (key: Key) => void
  reviewerRoles: ReviewerRole[]
}

export const AddMoreRoles = ({ handleAction, reviewerRoles }: Props) => {
  const menuItems = rolesMenuItems(reviewerRoles).filter((item) => item.enabled)
  if (!menuItems.length) return null

  return (
    <MenuTrigger placement="bottom-end" popoverClassName={Styles.itemsContainer}>
      <Button
        variant="tertiary"
        frontIcon={AddIcon}
        className={Styles.menuTrigger}
        size="sm"
        aria-label="Add More Types"
      >
        Add more types
      </Button>
      <Menu aria-label="Menu" onAction={handleAction}>
        {menuItems.map((menuItem) => (
          <Item key={menuItem.key} textValue={menuItem.textValue}>
            {menuItem.text}
          </Item>
        ))}
      </Menu>
    </MenuTrigger>
  )
}
